import React from "react"

import { Row, Col, Card, CardBody } from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import avatar1 from "../../assets/images/users/avatar-1.jpg"
import profileImg from "../../assets/images/profile-img.png"
const WelcomeComp = ({ last7, last30, name }) => {
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary" style={{ color: "#000000" }}>
                  Welcome Back !
                </h5>
                <h5
                  className="font-size-15 text-truncate"
                  style={{ color: "#000000" }}
                >
                  {name}
                </h5>
              </div>
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">{last7}</h5>
                    <p className="text-muted mb-0">
                      # of registrations (Last 7 days)
                    </p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">{last30}</h5>
                    <p className="text-muted mb-0">
                      # of registrations (Last 30 days)
                    </p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link to="/profile" className="btn btn-primary  btn-sm">
                    View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}
export default WelcomeComp
